import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getArenaList } from "@/api/arenaApi"

export default function ArenaListPage() {
  const q = useQuery({
    queryKey: ["arena-list"],
    queryFn: getArenaList,
    refetchInterval: 15_000,
  })

  return (
    <GameScreenLayout title="Арены" backTo="/play">
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : (
        <ul className="space-y-2">
          {(q.data ?? []).map((a) => (
            <li key={a.arenaId}>
              <Link
                to={`/play/arena/${encodeURIComponent(a.arenaId)}`}
                className="block rounded-xl border border-white/10 p-4 hover:border-guardians-accent/40"
              >
                <p className="font-medium">{a.name}</p>
                <p className="text-xs text-guardians-muted">
                  {a.cityName ?? "—"} · онлайн {a.onlineCount} · очередь{" "}
                  {a.queueSize}
                  {a.capacityFull ? " · полная" : ""}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </GameScreenLayout>
  )
}
